import React from 'react'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../auth/authSelectors'

const ImpersonationBanner = () => {
  const currentUser = useSelector(currentUserSelector)

  if (!currentUser.impersonating) return null

  return (
    <div className="header_impersonation">
      Impersonating {currentUser.name} / {currentUser.email}
    </div>
  )
}

export default ImpersonationBanner
